import { render, staticRenderFns } from "./ModalAddGrupo.vue?vue&type=template&id=298ce472&scoped=true&"
import script from "./ModalAddGrupo.vue?vue&type=script&lang=js&"
export * from "./ModalAddGrupo.vue?vue&type=script&lang=js&"
import style0 from "./ModalAddGrupo.vue?vue&type=style&index=0&id=298ce472&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298ce472",
  null
  
)

export default component.exports